import React, { useEffect } from 'react'
import { PrimaryButton, OutlineButton, SecondaryButton } from '..'
import './modalpopup.scss'
import GetimageBaseURL, {close} from '../../../assets/images';
import { useSelector } from 'react-redux';
import { selectors as imgSelector } from '../../../state/features/header';


interface IProps {
  closeModalPopup?: any,
  ModalPopupTitle?: string,
  ModalPopupType?: string,
  ShowModalPopupFooter?: any,
  FooterSecondaryBtnTxt?: any,
  FooterActionBtnTxt?:any,
  FooterPrimaryBtnTxt?: any,
  ModalPopupName?: string,
  children?: any,
  PrimaryBtnOnclick?:any,
  SecondryBtnOnclick?:any,
  ActionBtnOnclick?: any
}
const ModalPopup = ({
  ModalPopupType,
  ModalPopupTitle,
  closeModalPopup,
  ShowModalPopupFooter,
  FooterSecondaryBtnTxt,
  FooterActionBtnTxt,
  FooterPrimaryBtnTxt,
  ModalPopupName,
  children,
  PrimaryBtnOnclick,
  SecondryBtnOnclick,
  ActionBtnOnclick
}:IProps) => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
     document.body.classList.remove('modal-open')
    }
  }, [])

  const { imgBaseUrlSelectors }: any = useSelector((state) => ({
    imgBaseUrlSelectors: imgSelector.imgbaseUrl(state),
  }));
  const imgUrl = imgBaseUrlSelectors;

  return (
        <div className={`modalPopupMasterContainer ${ModalPopupName}`}>
          
            <div className='dropShadowcontainer'></div>
            <div className={`modalPopupContainer ${ModalPopupType}`}>
            <div className='modalPopupHeader'>
               <div className='modalTitle'>{ModalPopupTitle}</div>
                  {closeModalPopup && <div className='modalCloseIcon'><img src={GetimageBaseURL() + close} alt="close" onClick={closeModalPopup} onKeyDown={() => { }} /></div>}
            </div>
            <div className='modalPopupBody'>
            <div className="modalBodyContainer">
                    {children}
            </div>
            </div>
            {
            ShowModalPopupFooter
              ? <div className='modalPopupFooter'>
                <div className='footerButton'>
                {
                  FooterActionBtnTxt
                                      ? <OutlineButton text={FooterActionBtnTxt}  onClick={ActionBtnOnclick}></OutlineButton>
                    : null
                  }
                 
                 
                  {
                  FooterSecondaryBtnTxt
                    ? <SecondaryButton text={FooterSecondaryBtnTxt} title={FooterSecondaryBtnTxt} onClick={SecondryBtnOnclick}></SecondaryButton>
                    : null
                  }
                   {
                  FooterPrimaryBtnTxt
                                      ? <PrimaryButton text={FooterPrimaryBtnTxt} title={FooterPrimaryBtnTxt} onClick={PrimaryBtnOnclick}></PrimaryButton>
                    : null
                  }
                 </div>
            </div>
              : null}
        </div>
        </div>
  )
}

export default ModalPopup
